// 디바운스 (기획서 9.3 위치 저장 500ms, 8.3.5 resize 300ms)
export function debounce(fn, wait) {
  let timer = null;
  const debounced = (...args) => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      fn(...args);
    }, wait);
  };
  debounced.cancel = () => {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  };
  // 마지막 보류 호출을 즉시 실행 (책 닫을 때 미저장 위치 flush 용도)
  debounced.flush = (...args) => {
    if (timer) {
      clearTimeout(timer);
      timer = null;
      fn(...args);
    }
  };
  return debounced;
}
